import {
  compose,
  branch
} from 'recompose'

import FieldWrapperHOC from './FieldWrapperHOC.jsx'

export default compose(
  branch(props => props.formComponent, FieldWrapperHOC)
)



// WEBPACK FOOTER //
// ./components/hoc/FieldWrapperHOC/index.js